export const buildCdnUrl = (pathName: string) => {
  const cdnUrl = process.env.REACT_APP_CLOUDFRONT_CDN_URL || process.env.REACT_APP_IMAGEKIT_URL || ''

  if (!cdnUrl) {
    return pathName
  }

  return `${cdnUrl.replace(/\/$/, '')}/${pathName.replace(/^\//, '')}`
}

export const sanitizePathPart = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const getFileExtension = (fileName: string, fallback = 'bin') => {
  const extension = fileName.split('.').pop()

  return extension && extension !== fileName ? extension.toLowerCase() : fallback
}

export const formatFileSize = (size: number) => {
  if (!size) {
    return '0 B'
  }

  const units = ['B', 'KB', 'MB', 'GB']
  const unitIndex = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1)
  const value = size / 1024 ** unitIndex

  return `${value.toFixed(value >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`
}
